module.exports = __webpack_public_path__ + "static/media/sse-logo.67a2ae81.png";